<template>
  <div
    v-show="visible"
    ref="winning"
    v-loading.fullscreen="drawLoading"
    class="popup-giveaway-wrap"
  >
    <div class="popup-giveaway-container">
      <div class="popup-giveaway-header">
        <div>
          <img
            src="../images/popupGiveaway/logo.png"
            class="popup-giveaway-header-logo"
          >
        </div>
        <p>MILLIONS GIVEAWAY</p>
      </div>
      <div class="popup-giveaway-main">
        <div class="popup-giveaway-main-pkg absolute-middle">
          <div class="popup-giveaway-main-top" />
          <div class="popup-giveaway-main-bot" />
          <div class="popup-giveaway-main-amount absolute-middle">
            <p class="prize-info">
              <span>{{ data.total }}</span>
              <span class="unit">{{ $t('CURRENCY') }}</span>
              <img
                class="popup-giveaway-main-amount-vouchers"
                src="../images/popupGiveaway/vouchers.png"
              >
            </p>
          </div>
          <div class="popup-giveaway-main-text">
            AMAZING! YOU GOT
          </div>
        </div>
        <div class="popup-giveaway-main-light absolute-middle">
          <img
            src="../images/popupGiveaway/light.png"
            alt=""
            class="light"
          >
        </div>
        <img
          src="../images/popupGiveaway/img1.png"
          class="popup-giveaway-main-img1"
        >
        <img
          src="../images/popupGiveaway/img2.png"
          class="popup-giveaway-main-img2"
        >
        <img
          src="../images/popupGiveaway/img3.png"
          class="popup-giveaway-main-img3"
        >
      </div>
      <div
        v-if="!data.hiddenButton"
        class="popup-giveaway-btn"
      >
        <div
          class="popup-giveaway-btn-wrap"
          @click="handleShowOff"
        >
          Show Off
        </div>
        <div
          class="popup-giveaway-btn-wrap"
          @click="handleUse"
        >
          Use Now
        </div>
      </div>
      <div
        class="popup-giveaway-close"
        @click="closeVoucher"
      >
        <svg-icon icon-class="icon-close-round" />
      </div>
      <div
        v-if="data.showNotice"
        class="popup-giveaway-notice"
      >
        Notice: This is a Giveaway Voucher Template.
      </div>
    </div>
    <Share
      v-model="shareVisible"
      :share-title="data.messageTitle"
      :share-top-tips="shareData.shareTopTips"
      :share-imgs="shareData.shareImgs"
      :share-url="data.wapLink"
      :share-text="data.message"
      :has-hide-amount-btn="false"
      @close="onCloseShare"
    />
  </div>
</template>

<script>
import { elementDraw } from '@ms/ui/html2img'
import { dialogDownloadApp } from '@ms/utils/app/download.js'
import { gotoUseVoucher } from '@ms/components/userPush/vouchers'
import { prefixLink } from '@ms/config/app'
import { Share } from 'wap/components/index.js'
import { tryOpenApp } from 'wap/hybrid'
import VDialog from 'fe-vui/dialog'
import modalHelper from '@ms/utils/scroll-fixed'
import 'base/icons/svg/close-round.svg'

export default {
  name: 'Winning',
  components: {
    Share
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
      required: false
    },
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      hideAmount: false, // 绘图组件是否隐藏金额
      hideAmountChecked: false, // 隐藏金额按钮是否勾选
      shareElement: null,
      shareVisible: false,
      shareData: {
        shareTopTips: "You're so lucky! Share to tell your friends!",
        shareImgs: [] // 第一个元素为不隐藏金额，第二个元素为隐藏金额
      },
      drawLoading: false
    }
  },
  computed: {
    hostname() {
      return location.hostname
    }
  },
  methods: {
    async handleShowOff() {
      // 分享弹窗
      try {
        this.drawLoading = true
        const imgUrl = this.data.image
        const shareObj = {
          WH: [720, 979],
          backgroundColor: 'transparent',
          imageType: 'image/png',
          image: [
            {
              type: 'image',
              src: imgUrl,
              pos: [0, 0, 720, 979]
            }
          ],
          text: [
            {
              text: `${this.$t('CURRENCY')} ${this.data.total}`,
              type: 'text',
              pos: [508, 308],
              style: {
                color: '#e1c593',
                font: 'bold 60px arial',
                textAlign: 'center'
              }
            }
          ],
          quality: 1
        }
        // 等待绘图组件渲染完毕
        this.$nextTick(async () => {
          elementDraw(shareObj).then((res) => {
            this.shareData.shareImgs.push(res)
            this.shareVisible = true
            this.drawLoading = false
          })
        })
      } catch (error) {
        console.error(error)
        this.drawLoading = false
      }
    },
    handleUse() {
      // 跳转逻辑
      const { vouchers } = this.data
      if (vouchers[0].status === 1) {
        if (vouchers[0].platform && vouchers[0].platform.toLowerCase() === 'android') {
          this.openApp(vouchers[0].amount)
        } else {
          const bizType = this.data.bizType || []
          gotoUseVoucher(bizType)
        }
      } else {
        location.href = prefixLink('/vouchers')
      }
    },
    openApp(amount) {
      tryOpenApp('/params', {
        onfailed: () => dialogDownloadApp(`This voucher can be used on MSport app only. Download free app to get ${this.$t('CURRENCY')} ${amount} OFF now.`),
        force: true
      })
    },
    closeVoucher() {
      this.$emit('voucherShow', false)
      modalHelper.beforeClose()
      VDialog.close()
    },
    onCloseShare() {
      this.shareVisible = false
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.dialog-push.giveaway-dialog {
  .dialog {
    width: 100%;
    height: 100%;
  }
}

.popup-giveaway-container {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  text-align: center;
  transform: translate3d(-50%, -50%, 0);
}

.popup-giveaway-header {
  color: @white;
  font-size: 18/@rem;
  font-weight: bold;
  line-height: 44/@rem;
  text-shadow: #7b1515 1px 0 5/@rem;

  &-logo {
    width: 123/2/@rem;
  }
}

.popup-giveaway-btn {
  position: relative;
  z-index: 9;
  display: flex;
  width: 220/360 *100%;
  align-items: center;
  justify-content: space-between;
  margin: 20/@rem auto 0;
  animation: in-fade 1s 1.8s forwards;
  opacity: 0;

  &-wrap {
    width: 95/220 *100%;
    height: 25/@rem;
    box-sizing: border-box;
    border: 1px solid #bc8a46;
    border-radius: 25/@rem;
    background-image: linear-gradient(to top, #4ed3ae, #2d6666);
    color: @white;
    font-size: 12/@rem;
    line-height: 25/@rem;
  }
}

.popup-giveaway-close {
  position: relative;
  z-index: 9;
  width: 44/@rem;
  height: 44/@rem;
  margin: 15/@rem auto 0;
  animation: in-fade 1.5s 2s forwards;
  line-height: 44/@rem;
  opacity: 0;

  .svg-icon {
    color: @disabled;
    font-size: 24/@rem;
  }
}

.popup-giveaway-notice {
  margin-top: 8/@rem;
  animation: in-fade 1.5s 2.2s forwards;
  color: @white;
  font-size: 10/@rem;
  opacity: 0;
}

.popup-giveaway-main {
  position: relative;
  width: 303/@rem;
  height: 259/@rem;
  margin: 10/@rem auto 0;
  background: url("../images/popupGiveaway/bg.png") no-repeat center / 100% 100%;

  .absolute-middle {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }

  &-pkg {
    width: 239/@rem;
    height: 175/@rem;
  }

  &-top {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    animation: open-top 0.5s 0.5s forwards;
    background: url("../images/popupGiveaway/top.png") no-repeat center / 100% 100%;
  }

  &-bot {
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
    animation: open-bot 0.5s 0.5s forwards;
    background: url("../images/popupGiveaway/bot.png") no-repeat center / 100% 100%;
  }

  &-amount {
    z-index: 5;
    display: flex;
    height: 66/@rem;
    align-items: center;
    justify-content: center;
    animation: to-big 0.8s 1s ease-in-out forwards;
    color: #f5d398;
    font-size: 40/@rem;
    font-weight: bold;
    opacity: 0;
    text-shadow:
      2px 1px 2px #800706,
      2px 2px 2px #800706,
      2px 3px 2px #800706,
      2px 4px 2px #800706,
      2px 5px 2px #800706,
      2px 6px 4px #800706;
    transform: rotateZ(0) scale(0.3);

    .prize-info {
      position: relative;
    }

    .unit {
      position: absolute;
      top: -5/@rem;
      left: -40/@rem;
      font-size: 18/@rem;
      text-shadow:
        1px 1px 2px #800706,
        1px 2px 2px #800706,
        1px 3px 2px #800706,
        1px 4px 2px #800706;
    }

    &-vouchers {
      position: absolute;
      right: -70/@rem;
      bottom: -10/@rem;
      width: 78/@rem;
    }
  }

  &-text {
    position: absolute;
    z-index: 6;
    top: 27/@rem;
    left: 0;
    width: 100%;
    animation: in-fade 1s 0.5s forwards;
    color: @white;
    font-size: 15/@rem;
    opacity: 0;
    text-shadow: @dark 1px 0 3/@rem;
  }

  &-light {
    z-index: 3;
    top: 10/@rem;
    width: 300/@rem;
    height: 300/@rem;
    animation: light-in 0.8s 0.5s linear forwards;
    opacity: 0;
    transform-origin: 50% 50%;

    .light {
      width: 100%;
      animation: light-rotate 8s 1s linear infinite;
    }
  }

  &-img1 {
    position: absolute;
    top: 20/@rem;
    left: 12/@rem;
    width: 50/@rem;
    animation: bling 1.5s ease-in-out infinite alternate;
  }

  &-img2 {
    position: absolute;
    top: -5/@rem;
    right: 7/@rem;
    width: 48/@rem;
    animation: bling 2s 0.3s ease-in-out infinite alternate;
  }

  &-img3 {
    position: absolute;
    right: 5/@rem;
    bottom: 50/@rem;
    width: 45/@rem;
    animation: bling 1.1s 0.5s ease-in-out infinite alternate;
  }

  @keyframes open-top {
    from { transform: translate3d(0, 0, 0); }
    to { transform: translate3d(0, -47/@rem, 0); }
  }

  @keyframes open-bot {
    from { transform: translate3d(0, 0, 0); }
    to { transform: translate3d(0, 35/@rem, 0); }
  }

  @keyframes to-big {
    0% {
      opacity: 0;
      transform: scale(0.3);
    }

    50% {
      opacity: 1;
      transform: scale(1.3);
    }

    75% {
      opacity: 1;
      transform: scale(0.8);
    }

    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes light-rotate {
    0% {
      opacity: 1;
      transform: rotateZ(0);
    }

    100% {
      opacity: 1;
      transform: rotateZ(360deg);
    }
  }

  @keyframes in-fade {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes bling {
    from { opacity: 0.3; }
    to { opacity: 1; }
  }

  @keyframes light-in {
    from {
      opacity: 0;
      transform: scale(0, 0);
    }

    to {
      opacity: 1;
      transform: scale(1, 1);
    }
  }
}
</style>
